import Vue from "vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";

/**
 * The Mira edition the app bar names on the landing page, "Aus der Werkstatt · Oktober 2026" (Hans,
 * #2610137: the label of the beta showcase). The year and month of the edition, not of the data, which
 * carries its own "Stand" date: changed by hand with each showcase.
 */
export const MIRA_EDITION = "2026-10";

/**
 * A Mira page's title with the edition after it: "Trocknung · Aus der Werkstatt · Oktober 2026". The month
 * is written in the user's language by the browser, so a new edition is this one constant.
 */
export function miraEditionTitle(title: string, t: (key: string, params: string[]) => string, locale: string): string {
  const [year, month] = MIRA_EDITION.split("-").map(Number);
  const edition = new Intl.DateTimeFormat(locale, { month: "long", year: "numeric", timeZone: "UTC" }).format(
    new Date(Date.UTC(year, month - 1, 1))
  );
  return t("mira.edition", [title, edition]);
}

/** Sets the landing page's app bar title, "Mira" with the edition. Called again on a language change. */
export function setMiraToolbarTitle(vm: Vue, titleKey: string): void {
  ToolbarContentModule.setToolbarTitle(
    miraEditionTitle(vm.$t(titleKey).toString(), (key, params) => vm.$t(key, params).toString(), vm.$i18n?.locale ?? "de")
  );
}

/**
 * A Mira page below the landing, titled like any IRES Office sub-page: "Mira > Geschäftsentwicklung", without
 * the edition, which only the landing names (Hans, #2611027).
 */
export function miraPageTitle(title: string, t: (key: string) => string): string {
  return `${t("pages.mira")} > ${title}`;
}

/** Sets a Mira sub-page's app bar title, "Mira > Trocknung". Called again on a language change. */
export function setMiraPageTitle(vm: Vue, titleKey: string): void {
  const t = (key: string) => vm.$t(key).toString();
  ToolbarContentModule.setToolbarTitle(miraPageTitle(t(titleKey), t));
}
